import store from 'commons/store/Store';
import apiClient from 'commons/api/client/apiClient';

export enum UserLinkType {
  'FACEBOOK' = 'FACEBOOK',
  'INSTAGRAM' = 'INSTAGRAM',
  'TWITTER' = 'TWITTER',
  'YOUTUBE' = 'YOUTUBE',
  'BEHANCE' = 'BEHANCE',
  'DEVIANTART' = 'DEVIANTART',
  'PINTEREST' = 'PINTEREST',
  'TUMBLR' = 'TUMBLR',
  'TWITCH' = 'TWITCH',
  'VIMEO' = 'VIMEO',
  'CUSTOM' = 'CUSTOM',
}

export type UserLink = {
  type: UserLinkType;
  value: string;
};

export type ShowroomDataWithPossibleUndefineds = {
  description?: string;
  userImages?: {
    hasBanner: boolean;
  };
  userLinks?: UserLink[];
};

export type ShowroomData = {
  description: string;
  userImages: {
    hasBanner: boolean;
    bannerWidth?: number;
    bannerHeight?: number;
    bannerVersion?: string;
  };
  userLinks: UserLink[];
};

export type UserLinkConfig = {
  key: UserLinkType;
  name: string;
  icon: string;
  pattern?: string;
};

export const USER_LINK_SETTINGS: Record<UserLinkType, UserLinkConfig> = {
  [UserLinkType.FACEBOOK]: {
    key: UserLinkType.FACEBOOK,
    name: 'Facebook',
    icon: 'social-facebook',
    pattern: '^(\\d+|[A-Za-z0-9\\-\\.]+)$',
  },
  [UserLinkType.INSTAGRAM]: {
    key: UserLinkType.INSTAGRAM,
    name: 'Instagram',
    icon: 'social-instagram',
    pattern:
      '^([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\\.(?!\\.))){0,28}(?:[A-Za-z0-9_]))?)$',
  },
  [UserLinkType.TWITTER]: {
    key: UserLinkType.TWITTER,
    name: 'X',
    icon: 'social-x',
    pattern: '^@?[A-Za-z0-9_]{1,15}$',
  },
  [UserLinkType.YOUTUBE]: {
    key: UserLinkType.YOUTUBE,
    name: 'YouTube',
    icon: 'social-youtube',
    pattern: '^(channel\\/|user\\/|c\\/)?[A-Za-z0-9_\\-]+$',
  },
  [UserLinkType.BEHANCE]: {
    key: UserLinkType.BEHANCE,
    name: 'Behance',
    icon: 'social-behance',
  },
  [UserLinkType.DEVIANTART]: {
    key: UserLinkType.DEVIANTART,
    name: 'DeviantArt',
    icon: 'social-deviantart',
  },
  [UserLinkType.PINTEREST]: {
    key: UserLinkType.PINTEREST,
    name: 'Pinterest',
    icon: 'social-pinterest',
    pattern: '^[A-Za-z0-9_]{3,30}$',
  },
  [UserLinkType.TUMBLR]: {
    key: UserLinkType.TUMBLR,
    name: 'Tumblr',
    icon: 'social-tumblr',
    pattern: '^[A-Za-z0-9_\\.\\-]{1,32}$',
  },
  [UserLinkType.TWITCH]: {
    key: UserLinkType.TWITCH,
    name: 'Twitch',
    icon: 'social-twitch',
    pattern: '^[A-Za-z0-9][A-Za-z0-9_]{4,25}$',
  },
  [UserLinkType.VIMEO]: {
    key: UserLinkType.VIMEO,
    name: 'Vimeo',
    icon: 'social-vimeo',
  },
  [UserLinkType.CUSTOM]: {
    key: UserLinkType.CUSTOM,
    name: 'SHOWROOM_ADMIN.SOCIALS.CUSTOM',
    icon: 'link',
  },
};

export default {
  async getShowroomData() {
    const { data }: { data: ShowroomDataWithPossibleUndefineds } =
      await apiClient.request({
        method: 'GET',
        url: `/shopData/artist/${store.state.user.data.id}/showroomData`,
      });
    return data;
  },
  async updateShowroomData(showroomData: Partial<ShowroomData>) {
    const { data }: { data: ShowroomData } = await apiClient.request({
      method: 'POST',
      url: `/shopData/artist/${store.state.user.data.id}/showroomData`,
      data: showroomData,
    });
    return data;
  },
};
